export const general = {
  loading: "Please wait...",
  email: "Email address",
  password: "Password",
  search: "Search",
  today: "Today",

  btn_new: "Create new",
  btn_save: "Save",
  btn_delete: "Delete",
  btn_cancel: "Cancel",
  btn_reset: "Reset",
  btn_assign: "Add",
  btn_logout: "Log out",
  confirm_delete: "Are you sure you want to delete:\n\n",
  btn_print: "Print",
  btn_download: "Download",
  btn_close: "Close",
  btn_back: "Back",
  btn_show_qr: "Show QR code",
  qr_code_for: "This is the QR code for",
  send_qr_code: "Send this QR code",
  cancel: "Cancel",
  back: "Back",

  btn_reset_password: "Save",

  month_names: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],

  weekday_names_short: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
};
